import * as Sentry from "@sentry/react";

const configs = {
    development: {
        // apiUrl: 'https://api.theturbocar.com',
        apiUrl: 'http://arch.local:8603',
        env: 'development',
    },
    production: {
        apiUrl: 'https://api.theturbocar.com',
        env: 'production',
    },
};

type Environment = 'development' | 'production';

const currentEnv: Environment = (process.env.NODE_ENV as Environment) || 'development';

export const initSentry = () => {
    if (currentEnv === 'production') {
        Sentry.init({
            dsn: "https://cbdf7389f7ce45ad84c480703f61b917@sentry.onpy.ru/19",
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],
            // Tracing
            tracesSampleRate: 1.0, //  Capture 100% of the transactions
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [/^https:\/\/api.theturbocar.com\/api/],
            // Session Replay
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }
}

export const config = configs[currentEnv];
